import { useEffect, useRef, useState } from "react";

/**
 * A head that stays at the top of the canvas while the surface scrolls, and folds to one line once reading has started.
 * `compact` flips when the 40 px sentinel at the top of the surface leaves the scroll container; `headH` is the measured
 * height so a sticky rail can sit right under it.
 */
export function useStickyHead(active) {
  const headRef = useRef(null);
  const sentinelRef = useRef(null);
  const [compact, setCompact] = useState(false);
  const [headH, setHeadH] = useState(0);
  useEffect(() => {
    const s = sentinelRef.current;
    if (!active || !s || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver(([e]) => setCompact(!e.isIntersecting), { root: s.closest('[data-testid="project-canvas-scroll"]'), threshold: 0 });
    io.observe(s);
    return () => io.disconnect();
  }, [active]);
  useEffect(() => {
    const el = headRef.current;
    if (!active || !el || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(() => setHeadH(el.offsetHeight));
    ro.observe(el);
    setHeadH(el.offsetHeight);
    return () => ro.disconnect();
  }, [active]);
  return { headRef, sentinelRef, compact, headH };
}
